//
// Module for the Tax Tables and Rates add new lump sum tax rate view
//
rs.module("system_/configuration/taxtablesandrates/addlumpsumtaxrate",

    [
        "common/select-helper"
    ],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, federalTaxType, stateTaxType) {

            // Unpack js Selectors
            var criteria = $.js(jsSelectors.criteria);

            var taxTypeSelect = criteria.js(jsSelectors.taxTypeSelect);
            var stateSelect = criteria.js(jsSelectors.stateSelect);
            var voluntaryRateInput = criteria.js(jsSelectors.voluntaryRateInput);

            // Get select helper(s)
            var stateSelectHelper = selectHelper.getHelper(stateSelect);

            // On tax type change, determine if the state drop down is still enabled.
            taxTypeSelect.change(function () {
                stateSelectHelper.setDisabled(taxTypeSelect.val() == federalTaxType);
                stateSelectHelper.setValue('');

                voluntaryRateInput.prop('disabled', taxTypeSelect.val() == stateTaxType);
                voluntaryRateInput.val('');
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);